module.exports = __webpack_public_path__ + "img/progress-1.a5f911d1.png";